import React from 'react';

const NoMatch = () => {
    return (
        <div className="container">
            <div className="error text-center display-4 mt-5 pt-5 text-danger">
                <p><strong>404</strong> Page not found</p>
            </div>
        </div>
    );
};

export default NoMatch;